<template>
  <div>
    <p class="text-h6">
      Record the customer's general availability. They will get an email when a
      matching appointment becomes available.
    </p>
    <div v-if="smartMeterInterest.isFetched && Object.keys(interests).length">
      <div class="my-8">
        <div
          v-for="day in days"
          :key="day"
          class="d-flex flex-column flex-sm-row flex-wrap ga-2"
        >
          <SoCheckbox
            v-model="interests.interest[day].am"
            :data-testid="`interest-${day}-AM`"
            class="interest-checkbox"
            :label="`${capitalize(day)} AM`"
          />

          <SoCheckbox
            v-model="interests.interest[day].pm"
            :data-testid="`interest-${day}-PM`"
            class="interest-checkbox"
            :label="`${capitalize(day)} PM`"
          />
        </div>
      </div>
      <p class="text-h6">Additional info</p>
      <p class="mb-4">
        e.g. if the customer is due to be away on certain dates (the customer
        may still receive appointment slots during these times).
      </p>
      <SoTextarea v-model="interests.comment" data-testid="interest-comment" />
    </div>
  </div>
</template>

<script lang="ts">
  import SoCheckbox from "@/components/formControls/SoCheckbox.vue"
  import SoTextarea from "@/components/formControls/SoTextarea.vue"
  import { ImbpSmartMeterInterest } from "@/models/imbpSmartMeterInterest/imbpSmartMeterInterest"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { cloneDeep } from "lodash"
  import { defineComponent, PropType } from "vue"
  import { weekDays } from "@/constants/general"
  import { capitalize } from "@/helpers/stringHelpers"

  export default defineComponent({
    components: {
      SoCheckbox,
      SoTextarea,
    },
    props: {
      modelValue: {
        type: Object as PropType<ImbpSmartMeterInterest>,
        default: () => null,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        days: weekDays,
        current: useCurrentAccountStore(),
        interests: {} as ImbpSmartMeterInterest,
        capitalize,
      }
    },
    computed: {
      smartMeterInterest() {
        return this.current.imbpSmartMeterInterest
      },
    },
    watch: {
      interests: {
        handler(val) {
          this.$emit("update:modelValue", val)
        },
        immediate: true,
        deep: true,
      },
      "smartMeterInterest.data": {
        handler(val: ImbpSmartMeterInterest) {
          this.interests =
            cloneDeep(val) ?? new ImbpSmartMeterInterest(null, null)
        },
        immediate: true,
        deep: true,
      },
    },
  })
</script>

<style scoped>
  .interest-checkbox {
    min-width: 200px;
  }
</style>
